var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-editor-container"},[_vm._v(" 途聆日志平台，预留统计页 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }